import React from 'react';
import PropTypes from 'prop-types';
import { shallowEqual, useSelector } from 'react-redux';
import TranslationUtil from '../../utils/TranslationUtil';
import { getExpediaLinks, companyNames } from './links';

const linkSeparator = (key) => (<span key={key}>&nbsp;&nbsp;|&nbsp;&nbsp;</span>);

export function FooterLinks({ referrerBrand, footerHtml }) {
    const getPropsFromState = (state) => {
        const { app } = state;
        const { locale } = app;
        const translations = new TranslationUtil(app.translations, app.fallbackTranslations);
        const getTranslation = (suffix) => translations.getTranslation(`footer.${suffix}`);

        /* istanbul ignore next */
        const brandLinks = (getExpediaLinks(locale.canonical) || []).map((linkElement) => ({
            linkText: getTranslation(`links.${linkElement.key}`),
            link: linkElement.value
        }));

        return {
            links: brandLinks,
            companyName: companyNames[referrerBrand],
            rights: getTranslation('rights'),
            confidential: getTranslation('confidential')
        };
    };

    const {
        links,
        companyName,
        rights,
        confidential
    } = useSelector(getPropsFromState, shallowEqual);

    let id = 1;
    const reducer = (prev, curr) => (
        // eslint-disable-next-line no-plusplus
        (prev.length === 0) ? [curr] : [prev, linkSeparator(id++), curr]
    );

    return footerHtml
        ? (
            <div
                className="ulx-footer__linkgroup"
                // eslint-disable-next-line react/no-danger
                dangerouslySetInnerHTML={{ __html: footerHtml }}
            />
        )
        : (
            <div className="ulx-footer__linkgroup">
                <p>
                    {
                        links.map((element) => (
                            <a href={element.link} key={element.linkText}>{element.linkText}</a>
                        )).reduce(reducer, [])
                    }
                </p>

                <p className="ulx-footer__copyright">{`© ${new Date().getFullYear()} ${companyName} ${rights} ${confidential}`}</p>
            </div>

        );
}

FooterLinks.propTypes = {
    referrerBrand: PropTypes.string.isRequired,
    // eslint-disable-next-line react/require-default-props
    footerHtml: PropTypes.string
};

FooterLinks.displayName = 'FooterLinks';
export default FooterLinks;
